import createIcon from '../../createIcon';

/**
 * @component @name Apartment
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTFWM0g3VjdIM1YyMUgxMVYxN0gxM1YyMUgyMVYxMUgxN1pNNyAxOUg1VjE3SDdWMTlaTTcgMTVINVYxM0g3VjE1Wk03IDExSDVWOUg3VjExWk0xMSAxNUg5VjEzSDExVjE1Wk0xMSAxMUg5VjlIMTFWMTFaTTExIDdIOVY1SDExVjdaTTE1IDE1SDEzVjEzSDE1VjE1Wk0xNSAxMUgxM1Y5SDE1VjExWk0xNSA3SDEzVjVIMTVWN1pNMTkgMTlIMTdWMTdIMTlWMTlaTTE5IDE1SDE3VjEzSDE5VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Apartment = createIcon('Apartment', [
  [
    'path',
    {
      d: 'M17 11V3H7V7H3V21H11V17H13V21H21V11H17ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM15 15H13V13H15V15ZM15 11H13V9H15V11ZM15 7H13V5H15V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z',
      key: '12t0yi',
    },
  ],
]);

export default Apartment;
